import { size } from 'lodash'
import { createSelector } from '@reduxjs/toolkit'
import { Store } from 'builder/modules/store'
import { Columns } from './types'
import { columnize } from './utils'

export const selectJobTracking = (state: Store) => {
  return state.jobTracking
}

export const selectJobs = (state: Store) => {
  return state.jobTracking.jobs
}

export const selectAutoApplyWidgetJobs = (state: Store) => {
  return state.jobTracking.autoApplyWidget
}

export const savedJobs = createSelector([selectJobs], jobs => {
  const savedJobs = jobs.filter(({ status }) => status !== 'recommended')
  return savedJobs
})

export const selectWishlistCount = createSelector([selectJobs], jobs => {
  const wishlistJobs = jobs.filter(({ status }) => status === 'wishlist')
  return size(wishlistJobs)
})

export const selectAppliedMaxLimit = createSelector([selectJobs], jobs => {
  const appliedJobs = jobs.filter(({ status }) => status === 'applied')
  return size(appliedJobs) > 2
})

export const selectAppliedCount = createSelector([selectJobs], jobs => {
  const appliedJobs = jobs.filter(({ status }) => status === 'applied')
  return size(appliedJobs)
})

export const selectColumns = createSelector([selectJobs], (jobs): Columns => {
  return columnize(jobs)
})

export const selectFetchStatus = (state: Store) => {
  return state.jobTracking.fetchStatus
}

export const selectJobsOrder = createSelector([selectJobs], jobs => {
  return jobs.map(job => ({
    id: job.id,
    position_number: job.positionNumber,
    status: job.status,
  }))
})

export const selectAlreadyAppliedJob = (state: Store) => {
  return state.jobTracking.alreadyApplied
}

export const selectAutoTailoringStatus = (state: Store) => {
  return state.jobTracking.autoTailoringStatus
}

export const selectApplyTrackingDialog = (state: Store) => {
  return state.jobTracking.applyTrackingDialog
}

export const selectResumeList = (state: Store) => {
  return state.jobTracking.resumeList
}

export const selectResumeListFetchStatus = (state: Store) => {
  return state.jobTracking.resumeListFetchStatus
}

export const resumeSelection = (state: Store) => {
  return state.jobTracking.resumeSelection
}

export const selectFetchUpdateResumeStatus = (state: Store) => {
  return state.jobTracking.fetchUpdateResumeStatus
}

export const jtShowBanner = (state: Store) => {
  return state.jobTracking.jtShowBanner
}

export const hasInstalledExtension = (state: Store) => {
  return state.jobTracking.hasInstalledExtension
}

export const canInstallExtension = (state: Store) => {
  return state.jobTracking.canInstallExtension
}
export const notTrackedRecommendationsCount = (state: Store) => {
  return state.jobTracking.notTrackedRecommendationsCount || 0
}
